var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return ![
    "yektanet-rubika-adv",
    "yektanet-sheypoor-adv",
    "yektanet-technolife-adv",
    "yektanet-retail-basalam-adv"
  ].includes(_vm.getParam("account_custom_type"))
    ? _c(
        "div",
        {
          staticClass:
            "brand-section-container d-flex flex-column justify-content-center h-100"
        },
        [
          _c(
            "div",
            { staticClass: "brand-section-header text-center mb-3 mb-xl-4" },
            [
              _c(
                "div",
                { staticClass: "brand-section-header-logo mb-1" },
                [
                  _c("service-promotion-logo", {
                    staticStyle: { height: "120px" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "font-5" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("service_promotion_slogan.short")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: ["w-75 mx-auto", { rtl: _vm.$i18n.locale === "fa" }],
                  staticStyle: {
                    "font-size": "12px",
                    color: "#666",
                    "margin-top": "10px"
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("service_promotion_slogan.long")) +
                      "\n    "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "brand-section-body mx-auto" },
            _vm._l(_vm.showingServices, function(srvc) {
              return _c(
                "a",
                {
                  key: srvc.name,
                  staticClass: "brand-icon d-block",
                  attrs: {
                    href:
                      srvc.url +
                      "/?utm_source=accounts&utm_medium=logo&utm_term=" +
                      srvc.name +
                      "&utm_campaign=" +
                      _vm.utmCampaign,
                    target: "_blank",
                    "data-gtm-name":
                      _vm.utmCampaign === "login"
                        ? "login_service_links"
                        : "logout_service_link",
                    "data-gtm-value-one": srvc.name,
                    "data-gtm-value-two":
                      srvc.url +
                      "/?utm_source=accounts&utm_medium=logo&utm_term=" +
                      srvc.name +
                      "&utm_campaign=" +
                      _vm.utmCampaign
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleServiceClickEvent(srvc.name)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "brand-section-body-item" }, [
                    _c("div", { staticClass: "brand-section-body-item_logo" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.platformLogos[srvc.name],
                          alt: srvc.name + " logo"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "brand-section-body-item_intro" },
                      [
                        _c("span", { staticStyle: { "font-weight": "500" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(srvc.name + "_name")) +
                              "\n          "
                          )
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(srvc.name + "_slogan")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }